import { getApiBaseUrl, getStoredToken, safeApiRequest } from './apiClient';

const ENDPOINT = '/api/admin/mobile-apk-releases';

export const fetchApkReleases = async () => {
  return safeApiRequest(ENDPOINT, { method: 'GET', skipCsrf: true });
};

export const uploadApkRelease = async ({ file, versionCode, versionName, releaseNotes, forceUpdate }) => {
  const token = getStoredToken();
  const formData = new FormData();
  formData.append('file', file);
  formData.append('versionCode', String(versionCode));
  formData.append('versionName', versionName);
  if (releaseNotes) formData.append('releaseNotes', releaseNotes);
  formData.append('forceUpdate', forceUpdate ? 'true' : 'false');

  const csrfRes = await safeApiRequest('/api/auth/csrf-token', { method: 'GET', skipCsrf: true });
  const csrfToken = csrfRes?.veri?.csrfToken || csrfRes?.csrfToken;

  const response = await fetch(`${getApiBaseUrl()}${ENDPOINT}`, {
    method: 'POST',
    headers: {
      Authorization: `Bearer ${token}`,
      ...(csrfToken ? { 'X-CSRF-Token': csrfToken } : {}),
    },
    credentials: 'include',
    body: formData,
  });

  const json = await response.json().catch(() => ({}));
  if (!response.ok) {
    const err = new Error(json?.mesaj || 'APK yüklenemedi');
    err.status = response.status;
    throw err;
  }
  return json;
};

export const setApkReleaseActive = async (id, isActive) => {
  return safeApiRequest(`${ENDPOINT}/${id}/active`, {
    method: 'PATCH',
    body: { isActive },
  });
};

export const deleteApkRelease = async (id) => {
  return safeApiRequest(`${ENDPOINT}/${id}`, { method: 'DELETE' });
};

export const downloadApkRelease = async (id, filename) => {
  const token = getStoredToken();
  const response = await fetch(`${getApiBaseUrl()}${ENDPOINT}/${id}/download`, {
    method: 'GET',
    headers: { Authorization: `Bearer ${token}` },
    credentials: 'include',
  });

  if (!response.ok) {
    const json = await response.json().catch(() => ({}));
    const err = new Error(json?.mesaj || 'APK indirilemedi');
    err.status = response.status;
    throw err;
  }

  const blob = await response.blob();
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename || `unmak-mobile-${id}.apk`;
  document.body.appendChild(a);
  a.click();
  a.remove();
  window.URL.revokeObjectURL(url);
};
